module.exports = __webpack_public_path__ + "img/banner.84b7e3e9.png";